import React, { useState, useEffect } from "react";
import ProgressTabs from "../signup/ProgressTabs";
import { scrollSignupToTop } from "../signup/scrollSignup";
import Terms from "./Terms";
import OrgInfo from "./OrgInfo";
import Beliefs from "./Beliefs";
import Submit from "./Submit";

export default function NewOrgPage({ onSetUser }) {
    const [currentStep, setCurrentStep] = useState(0);
    const [formData, setFormData] = useState({
        name: "",
        username: "",
        email: "",
        password: "",
        bio: "",
        mission_statement: "",
        address: "",
        latitude: null,
        longitude: null,
        phone: "",
        website: "",
        pfp_url: "",
        links: []
    });
    const [beliefs, setBeliefs] = useState({
        denomination: "",
        niceneCreedAgreed: false,
    });
    const [termsAgreed, setTermsAgreed] = useState(false);

    const steps = [
        { label: "Terms & Conditions", number: 1 },
        { label: "Organization Info", number: 2 },
        { label: "Beliefs", number: 3 },
        { label: "Review & Submit", number: 4 }
    ];

    const handleNext = () => {
        if (currentStep < 3) {
            setCurrentStep(currentStep + 1);
        }
    };

    const handleBack = () => {
        if (currentStep > 0) {
            setCurrentStep(currentStep - 1);
        }
    };

    const handleFormDataUpdate = (updates) => {
        setFormData(prev => ({ ...prev, ...updates }));
    };

    useEffect(() => scrollSignupToTop(), [currentStep]);

    return (
        <main className="min-h-screen bg-primary text-text-primary px-4 py-8">
            <div id="signup-scroll-top" />
            <div className="max-w-4xl mx-auto">
                <h1 className="text-3xl font-bold mb-8 text-center">Create New Organization</h1>
                
                {/* Progress Tabs */}
                <ProgressTabs steps={steps} currentStep={currentStep} />

                {/* Step Content */}
                <div className="bg-secondary rounded-lg shadow-md p-8 border border-border">
                    {currentStep === 0 && (
                        <Terms 
                            termsAgreed={termsAgreed}
                            onTermsAgreedChange={setTermsAgreed}
                            onNext={handleNext}
                        />
                    )}
                    {currentStep === 1 && (
                        <OrgInfo 
                            formData={formData}
                            onFormDataUpdate={handleFormDataUpdate}
                            onBack={handleBack}
                            onNext={handleNext}
                        />
                    )}
                    {currentStep === 2 && (
                        <Beliefs 
                            formData={formData}
                            beliefs={beliefs}
                            onBeliefsUpdate={setBeliefs}
                            onBack={handleBack}
                            onNext={handleNext}
                        />
                    )}
                    {currentStep === 3 && (
                        <Submit 
                            formData={formData}
                            beliefs={beliefs}
                            termsAgreed={termsAgreed}
                            onBack={handleBack}
                            onSetUser={onSetUser}
                        />
                    )}
                </div>
            </div>
        </main>
    );
}
